import { Ass_03, Exp_01, Lia_01, Lia_02 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const INCOMING_VAT_INVOICE: Template = {
  id: "16e5e33c-6cee-4ba2-8fce-ec34ba402260",
  name: "Sissetulev arve KM-ga",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Invoice date",
      type: "date"
    },
    {
      name: "Payment date",
      type: "date"
    },
    {
      name: "Expense amount",
      type: "amount_eur"
    },
    {
      name: "VAT amount",
      type: "amount_eur"
    }
  ],
  generate: (values) => {
    const invoiceDate = findVariableValue("Invoice date", values);
    const paymentDate = findVariableValue("Payment date", values);

    const expenseAmount = Math.round(parseFloat(findVariableValue("Expense amount", values)) * 100);
    const vatAmount = Math.round(parseFloat(findVariableValue("VAT amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Arve summa",
          date: invoiceDate,
          amount: expenseAmount,
          eurAmount: expenseAmount,
          currency: "eur",
          debit: Exp_01,
          credit: Lia_01
        },
        {
          title: "Käibemaks",
          date: invoiceDate,
          amount: vatAmount,
          eurAmount: vatAmount,
          currency: "eur",
          debit: Lia_02,
          credit: Lia_01
        },
        {
          title: "Arve tasumine",
          date: paymentDate,
          amount: expenseAmount,
          eurAmount: expenseAmount,
          currency: "eur",
          debit: Lia_01,
          credit: Ass_03
        },
        {
          title: "KM tasumine",
          date: paymentDate,
          amount: vatAmount,
          eurAmount: vatAmount,
          currency: "eur",
          debit: Lia_01,
          credit: Ass_03
        }
      ]
    };

    return { type: "success", entry };
  }
};
